import { Pin02Icon } from '@langchain/untitled-ui-icons';

import { FC, useState } from 'react';

import { Tooltip } from '@/design-system';
import { cn } from '@/utils/tailwind';

const ModelConfigurationDefaultButton: FC<{
  isDefault: boolean;
  setDefaultConfigId: (id: string | undefined) => void;
  currentConfigId: string | undefined;
  isSavedConfig: boolean;
}> = ({ isDefault, setDefaultConfigId, currentConfigId, isSavedConfig }) => {
  const [isHovered, setIsHovered] = useState(false);
  if (!isSavedConfig) return null;

  const getButtonHoverClass = () => {
    if (isHovered) {
      return 'hover:border-brand-subtle hover:bg-brand-tertiary';
    }
    if (isDefault) {
      return 'hover:border-brand-subtle bg-brand-tertiary';
    }
    return '';
  };

  const getIconHoverClass = () => {
    if (isHovered) {
      return 'text-brand-tertiary [&_path]:fill-brand-green-400';
    }
    if (isDefault) {
      return 'text-brand-tertiary [&_path]:fill-brand-green-600';
    }
    return 'text-secondary';
  };

  return (
    <Tooltip title={isDefault ? 'Remove default' : 'Set as default'}>
      <button
        type="button"
        onClick={() => {
          if (isDefault) {
            setDefaultConfigId(undefined);
          } else {
            setDefaultConfigId(currentConfigId);
          }
          // remove hover state so there is visual indication of the change
          setIsHovered(false);
        }}
        className={cn(
          'rounded-md border border-transparent p-1',
          getButtonHoverClass()
        )}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div>
          <Pin02Icon
            className={cn(
              'h-5 w-5 [&_path]:stroke-[1.5px]',
              getIconHoverClass()
            )}
          />
        </div>
      </button>
    </Tooltip>
  );
};

export default ModelConfigurationDefaultButton;
